import { lazy } from 'react';

import { Location } from '@cobliteam/common-types';

const UserAlertPage = lazy(() => import('@cobliteam/user-alerts'));

const routes = [
  {
    path: Location.ALERTS,
    component: UserAlertPage,
    accessDeniedDescription: 'configurar notificações e alertas',
  },
];

export default routes;
